import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "col-md-2" }
const _hoisted_6 = { class: "row mb-2" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "table table-sm table-striped table-bordered table-hover" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "row mb-2" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "text-danger fw-bold" }

import { onMounted, reactive } from "vue";

//servicos
import * as service from "@/services/usuariosCidadesService";
import {Cidade} from "@/services/cidadesService";

//componentes
import TrataTecla from "@/components/TrataTecla/Index.vue";
import AutoCompleteCidade from "@/components/AutoCompletes/AutoCompleteCidade.vue";

interface IProps {
  UsuarioId?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UsuarioCidades',
  props: {
    UsuarioId: {}
  },
  setup(__props: any) {


//vue
var props = __props;

  var controle = reactive({

    cidades: [] as Cidade[],
    model: {
      usuarioId: props.UsuarioId
    } as service.UsuarioCidade,
    erro: "",
    status: ""
  })

  onMounted(() => {
   
    buscarCidades();

  });

  async function buscarCidades() {

      controle.status = "Buscando cidades...";
      controle.erro = "";
      service.ObterCidadesUsuario(props.UsuarioId || 0)
      .then((cidades) => {
        controle.cidades = cidades;
        controle.status = "";
      })
      .catch((error) => {
        controle.erro = `Erro ao buscar cidades: ${error}`;
        controle.status = "";
      });
    }
      

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TrataTecla, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("h5", { class: "card-title" }, "Cidades do Usuário")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("label", {
                for: "cidadeId",
                class: "form-label"
              }, "Cidade", -1)),
              _createVNode(AutoCompleteCidade, {
                modelValue: _unref(controle).model.cidadeId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).model.cidadeId) = $event)),
                id: "cidadeId"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("a", {
                class: "btn btn-sm btn-primary mt-4",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {service.adicionar(_unref(controle).model).then(() => { buscarCidades(); })})
              }, "Adicionar")
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Cidade"),
                    _createElementVNode("th", null, "Estado"),
                    _createElementVNode("th", null, "Código"),
                    _createElementVNode("th", null, "Ações")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).cidades, (cidade, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(cidade.nome), 1),
                      _createElementVNode("td", null, _toDisplayString(cidade.estado), 1),
                      _createElementVNode("td", null, _toDisplayString(cidade.cidadeId), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-danger",
                          onClick: ($event: any) => {service.excluir(cidade.cidadeId).then(() => { buscarCidades(); })}
                        }, "Excluir", 8, _hoisted_9)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, "Registros: " + _toDisplayString(_unref(controle).cidades.length), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(controle).status), 1),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(controle).erro), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})